/**
 * Area template interface.
 * 
 * @todo @export
 *
 * @interface AreaTemplate
 */
interface AreaTemplate {

  /** Area template id. */
  _id: string;

  /** Active state. */
  active: boolean;

  /** Functionality. */
  functionality: number;

  /** Is a parent. */
  isParent: boolean;

  /** Area template language. */
  language: 'en' | 'nl';

  /** Area template name. */
  name: string;

  /** Area template's parent. */
  parentId: {
    active: boolean;
    isParent: boolean;
    language: 'en' | 'nl';
    name: string;
    values: {
      _id: string;
      active: boolean;
      quality: string;
      techElementId: string;
      value: string;
    };
  };

  /** Area template values. */
  values: {
    _id: string;
    active: boolean;
    quality: string;
    techElementId: string;
    value: string;
  };

  /** Last updated as ISO string. */
  updated: string;
};
